export default __webpack_public_path__ + "static/media/pattern-runningBond1.6447e18d.jpg";